"use client"

import { useSearchParams } from "next/navigation"
import { useEffect } from "react"
import { getReferralDraft, setReferralDraft } from "../lib/referralStorage"
import {
  trackReferralLinkLanded,
  trackReferralLinkRejected,
} from "../lib/referralTracking"

// Mirror of the server's referralCode schema in attribute/route.ts.
const REF_CODE_REGEX = /^[a-z0-9]{6,16}$/i

export function ReferralCaptureURL() {
  const searchParams = useSearchParams()

  useEffect(() => {
    const raw = searchParams.get("ref")
    if (!raw) return

    const url = new URL(window.location.href)
    url.searchParams.delete("ref")
    window.history.replaceState(null, "", url.toString())

    if (!REF_CODE_REGEX.test(raw)) {
      trackReferralLinkRejected("invalid_code")
      return
    }
    const code = raw.toLowerCase()

    const previous = getReferralDraft()
    if (previous === code) return

    setReferralDraft(code)
    if (!previous) {
      trackReferralLinkLanded(code)
    }
  }, [searchParams])

  return null
}
